<template>
  <div>
    Display Attribute Edit/Replace Setup Here...
  </div>
</template>

<script>
export default {
  name: 'AttributeEditReplace',
  data: function () {
    return {
    }
  },
  computed: {
  },
  methods: { },
}
</script>

<style lang="scss" scoped>
</style>
